import { Alert } from "@mui/lab";
import { Button, CircularProgress, Grid2, Snackbar } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { ErrorModal } from "../../../../components/modals/error-modal";
import MesfModal from "../../../../components/modals/modal.mesf";
import { Job } from "../models/Job";
import { restartJob } from "../repositories/JobsRepository";

type Props = {
	jobSelected: Job | null;
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
};

export const ResetJob = ({ jobSelected, show, onHide }: Props) => {
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [openSnackbar, setOpenSnackbar] = useState(false);

	const resetJob = useMutation({
		mutationFn: restartJob,
		onSuccess: () => {
			setOpenSnackbar(true);
			onHide(true);
		},
		onError: (error: Error) => {
			setError(error.message);
		},
		onSettled: () => {
			setIsLoading(false);
		},
	});

	const onSubmit = async () => {
		setIsLoading(true);
		await resetJob.mutate(jobSelected?.JobId!);
	};

	return (
		<>
			<MesfModal
				title="RESET JOB"
				open={show}
				handleClose={() => onHide(false)}
				id="reset-job-modal"
			>
				<MesfModal.Content>
					Are you sure you want to reset? This action leaves the task in enable
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "16px 24px" }}>
					<Grid2 container spacing={2} justifyContent="flex-end">
						<Grid2 size={{ md: 3, xs: 12 }} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={() => onHide(false)}
							>
								Disagree
							</Button>
						</Grid2>
						<Grid2 size={{ md: 3, xs: 12 }} style={{ margin: 0 }}>
							<Button
								fullWidth
								startIcon={isLoading && <CircularProgress size="1rem" />}
								onClick={() => onSubmit()}
								disabled={isLoading}
								variant="contained"
								color="primary"
							>
								Agree
							</Button>
						</Grid2>
					</Grid2>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
			<Snackbar
				open={openSnackbar}
				autoHideDuration={2500}
				onClose={() => setOpenSnackbar(false)}
			>
				<Alert severity="success" onClose={() => setOpenSnackbar(false)}>
					The job was reseted succesfully
				</Alert>
			</Snackbar>
		</>
	);
};
